import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { linkify } from '../utils/linkify';
export function GanttRow({ row, rowH, timelineW, gridBackground, isEditor, onSelect, onStartEdit, onCommitCell, onCancelEdit, onOpenMenu, onDragStart, onDragOver, onDrop, onDragEnd, onPaintDown, onPaintMove, onSegDown, onSegClick, onSegDbl, onResizeDown, onGroupDown, onCellClick, paintCursor, }) {
    const id = row.id;
    const cellCursor = isEditor ? 'text' : 'default';
    const ddCursor = isEditor ? 'pointer' : 'default';
    const titlePad = isEditor ? '0 8px 0 2px' : '0 8px 0 19px';
    const minH = row.tlMinH ?? rowH;
    return (_jsxs("div", { "data-row": id, onClick: onSelect, onDragOver: (e) => {
            e.preventDefault();
            onDragOver(id);
        }, onDrop: (e) => {
            e.preventDefault();
            onDrop(id);
        }, className: "kp-row-hover", style: {
            display: 'flex',
            minHeight: minH,
            borderBottom: '1px solid #F1F5F9',
            borderTop: row.dropBorder,
            background: row.bg,
        }, children: [_jsxs("div", { "data-row": id, "data-field": "title", onDoubleClick: () => onStartEdit(id, 'title'), style: {
                    position: 'sticky',
                    left: 0,
                    zIndex: 15,
                    width: 280,
                    flex: 'none',
                    display: 'flex',
                    alignItems: 'center',
                    alignSelf: 'stretch',
                    background: row.bg,
                    borderRight: '1px solid #EEF2F7',
                    borderLeft: row.selBorder,
                    padding: titlePad,
                    overflow: 'hidden',
                    cursor: cellCursor,
                }, children: [isEditor ? (_jsx("span", { draggable: true, "data-row": id, onDragStart: (e) => {
                            onDragStart(id);
                            e.dataTransfer.effectAllowed = 'move';
                            try {
                                e.dataTransfer.setData('text/plain', id);
                            }
                            catch {
                                /* ignore */
                            }
                        }, onDragEnd: onDragEnd, title: "\u041F\u0435\u0440\u0435\u0442\u0430\u0449\u0438\u0442\u0435, \u0447\u0442\u043E\u0431\u044B \u0438\u0437\u043C\u0435\u043D\u0438\u0442\u044C \u043F\u043E\u0440\u044F\u0434\u043E\u043A", className: "kp-handle", style: {
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: 17,
                            flex: 'none',
                            color: '#CBD5E1',
                            fontSize: 11,
                            letterSpacing: -2,
                            cursor: 'grab',
                            userSelect: 'none',
                            paddingRight: 2,
                        }, children: "\u22EE\u22EE" })) : null, row.titleEditing ? (_jsx("input", { defaultValue: row.title, "data-row": id, "data-field": "title", autoFocus: true, onBlur: (e) => onCommitCell(id, 'title', e.currentTarget.value), onKeyDown: (e) => {
                            if (e.key === 'Enter')
                                e.currentTarget.blur();
                            else if (e.key === 'Escape')
                                onCancelEdit();
                        }, style: {
                            width: '100%',
                            height: 24,
                            border: '1px solid #2563EB',
                            borderRadius: 4,
                            padding: '0 6px',
                            fontSize: 12.5,
                            outline: 'none',
                        } })) : (_jsx("div", { style: {
                            fontSize: 12.5,
                            fontWeight: 600,
                            lineHeight: 1.35,
                            padding: '5px 0',
                            overflowWrap: 'anywhere',
                        }, children: row.titleParts?.map((tp, i) => (_jsx("span", { style: { color: tp.color }, children: tp.text }, i))) }))] }), _jsxs("div", { "data-menu-keep": "1", "data-row": id, "data-field": "type", onClick: (e) => onOpenMenu(id, 'type', e), style: {
                    position: 'sticky',
                    left: 280,
                    zIndex: 15,
                    width: 100,
                    flex: 'none',
                    display: 'flex',
                    alignItems: 'center',
                    alignSelf: 'stretch',
                    gap: 4,
                    background: row.bg,
                    borderRight: '1px solid #EEF2F7',
                    padding: '0 8px',
                    cursor: ddCursor,
                }, children: [_jsx("span", { style: {
                            fontSize: 10.5,
                            fontWeight: 600,
                            padding: '2px 7px',
                            borderRadius: 5,
                            background: row.typeBg,
                            color: row.typeColor,
                            border: `1px solid ${row.typeBd}`,
                            whiteSpace: 'nowrap',
                        }, children: row.type }), isEditor ? _jsx("span", { style: { marginLeft: 'auto', fontSize: 8, color: '#94A3B8' }, children: "\u25BE" }) : null] }), _jsxs("div", { "data-menu-keep": "1", "data-row": id, "data-field": "priority", onClick: (e) => onOpenMenu(id, 'priority', e), style: {
                    position: 'sticky',
                    left: 380,
                    zIndex: 15,
                    width: 90,
                    flex: 'none',
                    display: 'flex',
                    alignItems: 'center',
                    alignSelf: 'stretch',
                    gap: 4,
                    background: row.bg,
                    borderRight: '1px solid #EEF2F7',
                    padding: '0 8px',
                    boxShadow: '3px 0 6px rgba(15,23,42,.07)',
                    cursor: ddCursor,
                }, children: [_jsx("span", { style: {
                            fontSize: 10.5,
                            fontWeight: 700,
                            padding: '2px 9px',
                            borderRadius: 999,
                            background: row.prBg,
                            color: row.prColor,
                        }, children: row.pr }), isEditor ? _jsx("span", { style: { marginLeft: 'auto', fontSize: 8, color: '#94A3B8' }, children: "\u25BE" }) : null] }), row.cells?.map((cell) => (_jsx("div", { "data-row": id, "data-field": cell.key, onClick: onCellClick, onDoubleClick: () => onStartEdit(id, cell.key), title: cell.text, style: {
                    width: cell.w,
                    flex: 'none',
                    display: 'flex',
                    alignItems: 'center',
                    alignSelf: 'stretch',
                    justifyContent: cell.just,
                    padding: '0 8px',
                    borderRight: '1px solid #F5F8FB',
                    background: cell.bg,
                    overflow: 'hidden',
                    cursor: cellCursor,
                }, children: cell.editing ? (cell.wrap ? (_jsx("textarea", { defaultValue: cell.text, "data-row": id, "data-field": cell.key, autoFocus: true, rows: 3, onBlur: (e) => onCommitCell(id, cell.key, e.currentTarget.value), onKeyDown: (e) => {
                        if (e.key === 'Enter' && !e.shiftKey) {
                            e.preventDefault();
                            e.currentTarget.blur();
                        }
                        else if (e.key === 'Escape')
                            onCancelEdit();
                    }, style: {
                        width: '100%',
                        minHeight: 44,
                        border: '1px solid #2563EB',
                        borderRadius: 4,
                        padding: '4px 5px',
                        fontSize: 12,
                        lineHeight: 1.4,
                        outline: 'none',
                        fontStyle: 'normal',
                        resize: 'vertical',
                        fontFamily: 'inherit',
                    } })) : (_jsx("input", { defaultValue: cell.text, "data-row": id, "data-field": cell.key, autoFocus: true, onBlur: (e) => onCommitCell(id, cell.key, e.currentTarget.value), onKeyDown: (e) => {
                        if (e.key === 'Enter')
                            e.currentTarget.blur();
                        else if (e.key === 'Escape')
                            onCancelEdit();
                    }, style: {
                        width: '100%',
                        height: 22,
                        border: '1px solid #2563EB',
                        borderRadius: 4,
                        padding: '0 5px',
                        fontSize: 12,
                        outline: 'none',
                        fontStyle: 'normal',
                    } }))) : (_jsx("span", { "data-cell-content": "1", style: {
                        fontSize: 12,
                        lineHeight: 1.35,
                        whiteSpace: cell.wrap ? 'normal' : 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        overflowWrap: cell.wrap ? 'anywhere' : undefined,
                        maxHeight: cell.maxH,
                        color: cell.color,
                        fontStyle: cell.fs,
                    }, children: linkify(cell.text, cell.linkMax ?? Math.max(80, cell.w - 40)) })) }, cell.key))), _jsxs("div", { "data-row": id, onMouseDown: (e) => onPaintDown(id, e), onMouseMove: (e) => onPaintMove(id, e), style: {
                    width: timelineW,
                    flex: 'none',
                    position: 'relative',
                    backgroundImage: gridBackground,
                    cursor: paintCursor,
                    minHeight: minH,
                    alignSelf: 'stretch',
                    overflow: 'hidden',
                }, children: [row.groupSelected ? (_jsxs(_Fragment, { children: [_jsx("div", { style: {
                                    position: 'absolute',
                                    left: row.groupBoxL,
                                    top: 2,
                                    width: row.groupBoxW,
                                    bottom: 2,
                                    border: '1.5px dashed #2563EB',
                                    borderRadius: 7,
                                    pointerEvents: 'none',
                                    zIndex: 8,
                                } }), _jsx("div", { "data-seg-keep": "1", "data-row": id, onMouseDown: (e) => onGroupDown(id, e), title: "\u041F\u0435\u0440\u0435\u0442\u0430\u0449\u0438\u0442\u0435 \u043F\u0440\u043E\u0435\u043A\u0442 \u0432\u043B\u0435\u0432\u043E/\u0432\u043F\u0440\u0430\u0432\u043E", style: {
                                    position: 'absolute',
                                    left: row.grabLeft,
                                    top: row.grabTop,
                                    width: 18,
                                    height: 24,
                                    background: '#2563EB',
                                    borderRadius: 5,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    cursor: 'grab',
                                    zIndex: 11,
                                    color: '#DBEAFE',
                                    fontSize: 10,
                                    letterSpacing: -1.5,
                                    boxShadow: '0 2px 6px rgba(15,23,42,.3)',
                                    userSelect: 'none',
                                }, children: "\u22EE\u22EE" })] })) : null, row.segs?.map((seg) => (_jsxs("div", { "data-seg-keep": "1", "data-row": id, "data-seg": seg.i, onMouseDown: (e) => onSegDown(id, seg.i, e), onClick: (e) => onSegClick(id, seg.i, e), onDoubleClick: (e) => onSegDbl(id, seg.i, e), title: seg.tip, style: {
                            position: 'absolute',
                            top: seg.top,
                            height: seg.h,
                            left: seg.left,
                            width: seg.w,
                            background: seg.color,
                            borderRadius: 5,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            zIndex: seg.z,
                            boxShadow: seg.ring,
                            cursor: 'pointer',
                            opacity: seg.op,
                            pointerEvents: seg.pe,
                        }, children: [_jsx("span", { style: {
                                    display: seg.labelDisplay,
                                    fontSize: 10.5,
                                    fontWeight: seg.fw,
                                    color: seg.textColor,
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    maxWidth: '100%',
                                    padding: '0 4px',
                                }, children: seg.label }), seg.selected ? (_jsxs(_Fragment, { children: [_jsx("div", { "data-row": id, "data-seg": seg.i, "data-side": "l", onMouseDown: (e) => onResizeDown(id, seg.i, 'l', e), title: "\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C \u043D\u0430\u0447\u0430\u043B\u043E", style: {
                                            position: 'absolute',
                                            left: -5,
                                            top: '50%',
                                            marginTop: -8,
                                            width: 9,
                                            height: 16,
                                            background: '#FFFFFF',
                                            border: '1.5px solid #2563EB',
                                            borderRadius: 3,
                                            cursor: 'ew-resize',
                                            zIndex: 12,
                                        } }), _jsx("div", { "data-row": id, "data-seg": seg.i, "data-side": "r", onMouseDown: (e) => onResizeDown(id, seg.i, 'r', e), title: "\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C \u0434\u043B\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0441\u0442\u044C", style: {
                                            position: 'absolute',
                                            right: -5,
                                            top: '50%',
                                            marginTop: -8,
                                            width: 9,
                                            height: 16,
                                            background: '#FFFFFF',
                                            border: '1.5px solid #2563EB',
                                            borderRadius: 3,
                                            cursor: 'ew-resize',
                                            zIndex: 12,
                                        } })] })) : null] }, seg.i)))] })] }));
}
